<script setup>
import { computed } from 'vue'
import { StrapiBlocks } from 'vue-strapi-blocks-renderer'
import { strapiQuery } from '@/composables/strapiQuery'

const props = defineProps({
  slot: {
    type: String,
    required: true
  }
})

const { data, loading } = strapiQuery(`api/texts?filters[slot][$eq]=${props.slot}`)

// StrapiBlocks fails without initial content.
const content = computed(() => {
  if (data.value && data.value.length > 0) {
    return data.value[0].content
  }
  return [
    {
      type: 'paragraph',
      children: [{ type: 'text', text: '' }]
    }
  ]
})
</script>

<template>
  <v-progress-linear v-if="loading" indeterminate color="primary" />
  <StrapiBlocks v-else :content="content" />
</template>
